import React from 'react';

export default function Incorrect() {
  return <>{ `Good try, but not quite right :(` }</>;
}